module.exports = __webpack_public_path__ + "img/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/logo.png
// module id = 972
// module chunks = 0